import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  static targets = ["tooltip"];

  connect() {
    this.tooltips = Array.from(this.element.querySelectorAll('[data-bs-toggle="tooltip"]')).map(
      (tooltipEl) => new bootstrap.Tooltip(tooltipEl)
    );

  }

  disconnect() {
    if (this.tooltips) {
      this.tooltips.forEach((tooltip) => tooltip.dispose());
    }
  }
}
